import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-joiningdetails-form',
  templateUrl: './joiningdetails-form.component.html',
  styleUrls: ['./joiningdetails-form.component.css']
})
export class JoiningdetailsFormComponent implements OnInit {

  title = "Add Joining Details";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/serviceregister/joiningdetails/joiningdetails-form/joiningdetails-form.component.ts